import useWebSocket from 'react-use-websocket';
import useIsOnline from './useIsOnline';

interface AuthToken {
  token: string;
}

export default function useWebsocketSetup<T = unknown>(
  socketUrl: string,
  enabled: boolean = true
) {
  const authData = localStorage.getItem('authorization');
  const authToken: AuthToken = authData ? JSON.parse(authData) : { token: '' };
  const isOnline = useIsOnline();

  const shouldConnect = isOnline && enabled;

  const { sendJsonMessage, lastJsonMessage, readyState } = useWebSocket<T>(
    import.meta.env.REACT_APP_WEBSOCKET_URL + socketUrl,
    {
      onOpen: () => console.log('WebSocket Connected'),
      onError: (event: WebSocketEventMap['error']) =>
        console.log('WebSocket error:', event),
      onMessage: (event: WebSocketEventMap['message']) =>
        console.log('WebSocket message:', event),
      queryParams: { token: authToken.token },
      // Will attempt to reconnect on all close events, such as server shutting down
      shouldReconnect: () => isOnline,
    },
    shouldConnect
  );

  return { sendJsonMessage, lastJsonMessage, readyState };
}
